<template>
  <div id="app" class="page-container">
    <Header class="header" v-if="header_show" />
    <main class="content">
      <!-- 内容部分 -->
      <keep-alive>
        <router-view class="main_warp" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view class="main_warp" v-if="!$route.meta.keepAlive" />
    </main>
    <Footer class="footer" v-if="footer_show" />
    <Login />
    <PledgeLetter />
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Login from '@/components/Login'
import PledgeLetter from '@/components/PledgeLetter'
export default {
  components: {
    Header,
    Footer,
    Login,
    PledgeLetter
  },
  name: 'App',
  data () {
    return {
      header_show: true,
      footer_show: true
    }
  },
  watch: {
    '$route' (to, from) {
      this.activeIndex = to.path
      /** 自适应 */
      this.header_mc_show = false
      this.footer_mc_show = false
      if (this.activeIndex == '/login') {
        this.header_show = false
        this.footer_show = false
      } else {
        this.header_show = true
        this.footer_show = true
      }
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style>
@import '@/assets/css/common.css';
.highlight-row {
  background-color: #bdefff!important; /* 浅红色背景 */
}
#left_box .el-collapse-item__header {
    line-height: 120%!important;
    height: auto!important;
}
.custom-table-header th {
  background-color: #205dae !important;
  color: #fff !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 确保容器占满整个视口高度 */
}

.header, .footer {
  flex-shrink: 0; /* 头部和底部不收缩 */
}

.content {
  flex-grow: 1; /* 内容部分填充剩余空间 */
  padding-top: 140px; /* 为header预留空间 */
}
</style>
